/**
 * AI 助教默认欢迎语
 */
export const DEFAULT_AI_TA_WELCOME = "你好！我是你的AI助教，有什么可以帮助你的吗？"
